import { CompanySummary } from "../useCompanies/useCompanies";
import { CombinedSummary } from "./types";

function convertCompaniesToCombined(
  companies: CompanySummary[]
): CombinedSummary {
  const result: any = {};

  if (companies) {
    for (let i = 0; i < companies.length; i++) {
      const company = companies[i];
      result[company.id] = {
        name: company.name,
        branches: [{ name: "Loading..." }],
        searchResult: company.searchResult
      };
    }
  }
  return result;
}

export default convertCompaniesToCombined;
